export default __webpack_public_path__ + "static/media/sideNavBot.ffac7a6e.png";